import useGetResidentsByOccupancy from './useGetResidentsByOccupancy'

/**
 * @param {RichResidentObject} resident
 * @param {boolean?} includeSelf
 * @param {boolean?} includePast
 */
function useGetRoommates(resident, includeSelf = false, includePast = false) {
  const allOccupants = useGetResidentsByOccupancy(resident.occupancy.id, includePast)
  const roommates = includeSelf ? allOccupants : allOccupants.filter(r => r.id !== resident.id)

  return {
    roommates: roommates,
    roommateNames: roommates.map(r => r.displayName),
  }
}

export default useGetRoommates
